import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { faqs } from "../../mock";

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-5">
        <div className="text-center">
          <span className="text-sm font-bold tracking-[0.2em] text-[#ec4899] uppercase">
            Perguntas frequentes
          </span>
          <h2 className="mt-4 font-display font-bold text-white text-3xl md:text-5xl leading-tight">
            Ainda tem dúvidas?
          </h2>
          <p className="mt-6 text-gray-400 text-lg max-w-xl mx-auto leading-relaxed">
            Reunimos as perguntas mais comuns para te ajudar.
          </p>
        </div>

        <div className="mt-12 space-y-4">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`rounded-2xl border bg-[#0f0e17] overflow-hidden transition-all ${
                  isOpen ? "border-[#ec4899]/40" : "border-white/8"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                >
                  <span className="font-semibold text-white text-base md:text-lg">
                    {f.q}
                  </span>
                  <span
                    className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                      isOpen ? "bg-[#ec4899] text-white" : "bg-white/8 text-gray-300"
                    }`}
                  >
                    {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    isOpen
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-gray-400 leading-relaxed">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
